import React from 'react';

import { Table } from '@views/components/cart';
import { TABLE_HEADER, ACTION } from '../../intl';
import get from 'lodash/get';

import { Product as CartProduct } from '@views/components/cart';
import LazyImage from '@views/components/lazy-image';
import useLayoutContext from '@views/layouts/hooks/use-context';

import cn from 'classnames';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';

const GiftRow = ({ gift }) => {
  const {
    checkout: { handleCleanGift },
  } = useLayoutContext();

  return (
    <Table.Row key={get(gift, 'id')}>
      <Table.Col product data-title={TABLE_HEADER.PRODUCT}>
        <CartProduct>
          <a className="cart-product__image">
            <LazyImage
              className="d-block w-100"
              alt={get(gift, 'name')}
              src={get(gift, 'image')}
            />
          </a>
          <CartProduct.Info>
            <div className="cart-product__name">{get(gift, 'name')}</div>
            <div style={{ fontStyle: 'italic' }}>Quà tặng</div>
          </CartProduct.Info>
        </CartProduct>
      </Table.Col>
      <Table.Col price data-title={TABLE_HEADER.PRICE}>
        <span className="text-primary">Miễn phí</span>
      </Table.Col>
      <Table.Col
        quantity
        data-title={TABLE_HEADER.QUANTITY}
        className="d-md-table-cell d-none"
      >
        1
      </Table.Col>
      <Table.Col
        total
        data-title={TABLE_HEADER.TOTAL}
        className="d-md-table-cell d-none"
      >
        <span className="text-primary">Miễn phí</span>
      </Table.Col>
      <Table.Col action reversedLink data-title={TABLE_HEADER.ACTION}>
        <a
          onClick={handleCleanGift}
          className={cn(EVENT_CLASS_NAME)}
          data-category={EVENT_CATEGORY.DELETE_GIFT}
          data-action={EVENT_ACTION_NAME}
          data-label={get(gift, 'name')}
        >
          {ACTION.DELETE}
        </a>
      </Table.Col>
    </Table.Row>
  );
};

export default GiftRow;
